import { odata } from '../../conf';

const actions = {
  async LOAD_xeroRecons({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('xeroRecons')
      .query();
    commit('SET_xeroRecons', data);
  },
};

export default actions;
